module.exports = __webpack_public_path__ + "fad8417b278625d9e0084532833f5dad.MP3";